// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1tHxk","title":"InfoRow_title__54Qqz"};